module.exports = __webpack_public_path__ + "static/media/speaker_test.d00f43ce.mp3";